/**
 * Register the service worker for PWA / offline support.
 * Called once from index.js / App boot.
 */
export function registerServiceWorker() {
  if (process.env.NODE_ENV === "development") {
    // CRA dev server serves with HMR; SW would conflict. Allow only in prod-like envs.
    if (!window.location.hostname.endsWith("emergentagent.com")) return;
  }
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((reg) => {
        console.info("[TrueLine] SW registered:", reg.scope);
        // try to drain outbox when we come back online
        window.addEventListener("online", () => {
          navigator.serviceWorker.controller?.postMessage("drain-outbox");
        });
      })
      .catch((err) => console.warn("[TrueLine] SW registration failed:", err));
  });
}
